const giftCardUtility = {
    pinInputCheck: (event) => {
        if (
            event.target.value &&
            event.target.value.match(/^[0-9]+$/) !== null &&
            event.target.value.length < 5
        ) {
            return true;
        }
        return false;
    },
    createPinEventProps: (event) => {
        const data = { giftCardPin: event.target.value };
        const eventProps = { field: 'giftCardPin', data };
        return [event, eventProps];
    },
    cardInputCheck: (event) => {
        if (
            event.target.value &&
            event.target.value.match(/^[0-9]+$/) !== null &&
            event.target.value.length < 20
        ) {
            return true;
        }
        return false;
    },
    isTargetValueEmpty: (event) => {
        if (event.target.value === '') {
            return true;
        }
        return false;
    },
    createCardEventProps: (event) => {
        const data = { giftCardNum: event.target.value };
        const eventProps = { field: 'giftCardNum', data };
        return [event, eventProps];
    },
};

export default giftCardUtility;
